<template>
	<div class="checkout-section-container">
		<div :id="identity" class="field is-horizontal">
			<div class="field-label">
				<label class="label is-size-5 is-size-5-5-mobile">{{ label }}</label>
			</div>
			<div class="field-body flex-column">
				<slot></slot>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			identity: {
				type: String,
				default: () => {
					console.error(`Checkout section needs an identity`);
					return 'section-default-identity';
				}
			},
			label: {
				type: String,
				default: () => {
					console.warn(`Section ${this.identity} is missing a label`);
					return 'Section';
				},
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import "globalStyles";
	.checkout-section-container {
		padding: 2em 0;
		border-bottom: 1px solid $greyOutline;
		&:first-of-type {
			padding-top: 0;
		}
		&:last-of-type {
			border: none;
		}
		max-width: 700px;
		.field {
			max-width: 90vw;
			.flex-column {
				max-width: 100%;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/checkout/CheckoutSection.vue